module.exports = __webpack_public_path__ + "static/Event_Add_highres-a453fd58d5427189c9e6136164e4e1f9.jpg";